if (!customElements.get('add-to-cart-button')) {
class AddToCartButton extends HTMLElement {
  constructor() {
    super();
    this.handleAddToCart = this.handleAddToCart.bind(this);
  }

  connectedCallback() {
    this.cart = this.closest('cart-drawer') || document.querySelector('cart-drawer');
    this.ga4JsonData =
      this.getAttribute('data-ga4-product') ||
      this.getAttribute('data-cart-recommend-ga4-product');
    this.ga4TrackClick = this.hasAttribute('data-ga4-track-click');
    this.ga4Position = this.getAttribute('data-ga4-position');
    this.ga4Currency = this.getAttribute('data-ga4-currency') || 'USD';
    this.addEventListener('click', this.handleAddToCart);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleAddToCart);
  }

  getCheckoutForm() {
    return this.closest('product-form') || this.closest('form.ug-checkout-addtocart-form');
  }

  parseNotePropertiesAttr() {
    const raw =
      this.querySelector('.t4s-pr-addtocart')?.getAttribute('data-note-properties') ||
      this.getAttribute('data-note-properties');
    if (!raw) return {};

    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        return parsed;
      }
      console.warn('[add-to-cart-button] data-note-properties must be a JSON object');
    } catch (error) {
      console.warn('[add-to-cart-button] Invalid data-note-properties JSON:', error);
    }

    return {};
  }

  getPropertiesFromForm() {
    const form = this.getCheckoutForm();
    if (!form) return {};

    const properties = {};
    form.querySelectorAll('[name^="properties["]').forEach((input) => {
      const name = input.getAttribute('name');
      const match = name?.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = input.value;
    });
    return properties;
  }

  getNoteProperties() {
    return { ...this.parseNotePropertiesAttr(), ...this.getPropertiesFromForm() };
  }

  setLoadingState(button, isLoading) {
    const spinner = button.querySelector('.loading__spinner');
    const buttonText = button.querySelector('.button-text');

    if (isLoading) {
      button.classList.add('loading');
      button.setAttribute('aria-disabled', true);
      spinner?.classList.remove('hidden');
      buttonText?.classList.add('hidden');
    } else {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
      buttonText?.classList.remove('hidden');
    }
  }

  async handleAddToCart(event) {
    const button = event.target.closest?.('.t4s-pr-addtocart');
    if (!button || !this.contains(button)) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    if (this.ga4JsonData && this.ga4TrackClick) {
      this.ga4Event('cart_recommend_click');
    }

    this.setLoadingState(button, true);

    const config = fetchConfig('javascript');
    try {
      const formData = new FormData();
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      formData.append('id', variantId);

      const useQuantityInput = button.hasAttribute('data-quantity-control');
      const quantity = useQuantityInput
        ? parseInt(document.querySelector('.quantity__input')?.value || 1, 10)
        : 1;
      formData.append('quantity', quantity);

      Object.entries(this.getNoteProperties()).forEach(([key, value]) => {
        formData.append(`properties[${key}]`, value);
      });

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      const response = await fetch(`${routes.cart_add_url}`, config);
      const data = await response.json();

      // if(window.Glood){
      //   await Glood.upsell.commitPickSelections({
      //     triggerVariantId: data.variant_id
      //   })
      // }

      if (data.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: data.errors || data.description,
          message: data.message,
        });
        this.handleErrorMessage(data.description);

        const soldOutMessage = button.querySelector('.sold-out-message');
        if (soldOutMessage) {
          button.setAttribute('aria-disabled', true);
          button.querySelector('.button-text')?.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
        }
        this.error = true;
        return;
      }

      if (this.ga4JsonData) {
        this.ga4Event();
      }

      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!this.error) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: data,
        });
      }

      this.error = false;
      this.cart.renderContents(data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      this.setLoadingState(button, false);

      if (this.cart?.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }
    }
  }
  ga4Event(phase = null) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics?.publish) return;

    let productData;
    try {
      productData = JSON.parse(this.ga4JsonData);
    } catch (error) {
      console.warn('[add-to-cart-button] Invalid GA4 product data:', error);
      return;
    }

    const product_list_data = [productData];
    const value = product_list_data.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
    const isCartRecommendClick = phase === 'cart_recommend_click';
    const isCartRecommend = this.ga4Position === 'cart-drawer-recommendations';

    const event_parameters = {
      currency: this.ga4Currency,
      value: value,
      items: product_list_data,
    };
    if (this.ga4Position) event_parameters.position = this.ga4Position;

    Shopify.analytics.publish('ga4Event', {
      log_name: isCartRecommendClick
        ? '购物车推荐商品加购点击:'
        : isCartRecommend
          ? '购物车推荐商品加入购物车'
          : '产品加购按钮点击:',
      event_name: isCartRecommendClick
        ? 'cart_recommend_add_to_cart_click'
        : 'add_to_cart',
      event_parameters,
    });
  }
}

  customElements.define('add-to-cart-button', AddToCartButton);
}
